export const OWA_ROOT_PREFIX: string = '/owa/';
